"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MomentTimeControls = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../../atoms");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Moment Time Controls
var MomentTimeControls = function MomentTimeControls(_ref) {
  var startAt = _ref.startAt,
      stopAt = _ref.stopAt,
      onChangeStartStop = _ref.onChangeStartStop,
      duration = _ref.duration,
      fullGameMomentDuration = _ref.fullGameMomentDuration,
      fullGameMoment = _ref.fullGameMoment;

  var onBackward = function onBackward(e, noSec) {
    var newStartAt = startAt - noSec;

    if (newStartAt >= 0) {
      var newStopAt = stopAt - noSec;
      onChangeStartStop(newStartAt, newStopAt);
    }
  };

  var onForward = function onForward(e, noSec) {
    var newStartAt = startAt + noSec;

    if (newStartAt >= 0 && newStartAt <= fullGameMomentDuration) {
      var newStopAt = stopAt + noSec;
      onChangeStartStop(newStartAt, newStopAt);
    }
  };

  var onShrink = function onShrink(e, noSec) {
    var newStopAt = stopAt - noSec;
    var newLength = Math.floor(newStopAt - startAt);

    if (newLength >= 2) {
      onChangeStartStop(startAt, newStopAt);
    }
  };

  var onLengthen = function onLengthen(e, noSec) {
    var newStopAt = stopAt + noSec;
    var newLength = Math.floor(newStopAt - startAt);
    var maxDuration = fullGameMoment.sport_type === "baseball" ? 200 : 80;

    if (newLength <= maxDuration) {
      onChangeStartStop(startAt, newStopAt);
    }
  };

  var offsetStartAt = fullGameMoment && fullGameMoment.time ? fullGameMoment.time + startAt : startAt;
  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    marginTop: "2",
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "personalize-controls-spotlight"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: "Start",
    marginTop: "4",
    marginBottom: "4",
    color: _atoms.Color.Grey2,
    bold: true,
    type: _atoms.Label.Type.Heading5
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "personalize-controls-spotlight",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    marginRight: "6",
    width: "var(--spacing-9x)",
    trkAction: "Start -30 seconds Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "24",
    type: _atoms.Icon.Type.JumpBack30,
    color: _atoms.Color.Trace,
    onClick: function onClick(e) {
      return onBackward(e, 30);
    }
  })), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    marginRight: "4",
    width: "var(--spacing-9x)",
    trkAction: "Start -2 seconds Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "24",
    type: _atoms.Icon.Type.Back2,
    color: _atoms.Color.Trace,
    onClick: function onClick(e) {
      return onBackward(e, 2);
    }
  })), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: (0, _utils.formatMinutesAndSeconds)(offsetStartAt),
    marginTop: "4",
    marginBottom: "4",
    color: _atoms.Color.Black,
    type: _atoms.Label.Type.Body
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    marginLeft: "4",
    width: "var(--spacing-9x)",
    trkAction: "Start +2 seconds Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "24",
    type: _atoms.Icon.Type.Forward2,
    color: _atoms.Color.Trace,
    onClick: function onClick(e) {
      return onForward(e, 2);
    }
  })), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    marginLeft: "4",
    marginRight: "2",
    width: "var(--spacing-9x)",
    trkAction: "Start +30 seconds Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "24",
    type: _atoms.Icon.Type.JumpForward30,
    color: _atoms.Color.Trace,
    onClick: function onClick(e) {
      return onForward(e, 30);
    }
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    marginTop: "10",
    className: "personalize-controls-spotlight"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: "Duration",
    marginTop: "4",
    marginBottom: "4",
    color: _atoms.Color.Grey2,
    bold: true,
    type: _atoms.Label.Type.Heading5
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "personalize-controls-spotlight",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    marginRight: "4",
    width: "var(--spacing-14x)",
    trkAction: "Duration -2 seconds Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "24",
    type: _atoms.Icon.Type.Cut2Seconds,
    color: _atoms.Color.Trace,
    onClick: function onClick(e) {
      return onShrink(e, 2);
    }
  })), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: Math.floor(duration),
    marginTop: "4",
    marginBottom: "4",
    color: _atoms.Color.Black,
    type: _atoms.Label.Type.Body
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    marginLeft: "4",
    width: "var(--spacing-14x)",
    trkAction: "Duration +2 seconds Pressed"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: "24",
    type: _atoms.Icon.Type.Add2Seconds,
    color: _atoms.Color.Trace,
    onClick: function onClick(e) {
      return onLengthen(e, 2);
    }
  }))));
};

exports.MomentTimeControls = MomentTimeControls;
MomentTimeControls.defaultProps = {
  stopAt: 0.0,
  startAt: 0.0
};